import { createRequestTypes, actionCreator } from './index';
import omit from 'lodash/omit';

export const SET_USER_DATA = createRequestTypes('SET_USER_DATA');

export const setUserData = (user) => {
    let reduxUser = user ? {...omit(user, "userRole"), role: user.userRole} : {};
    return (dispatch) => {
        dispatch(actionCreator.success(SET_USER_DATA, reduxUser));
    }
}

export const emptyUserData = () => {
    return (dispatch) => {
        dispatch(actionCreator.empty(SET_USER_DATA))
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/userActions.js